import { render, staticRenderFns } from "./Estimasi.vue?vue&type=template&id=c0f07820&scoped=true"
import script from "./Estimasi.vue?vue&type=script&lang=js"
export * from "./Estimasi.vue?vue&type=script&lang=js"
import style0 from "./Estimasi.vue?vue&type=style&index=0&id=c0f07820&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f07820",
  null
  
)

export default component.exports